const PATCH_REQUEST_TYPE = {
  DAILY_REPORT_STATUS_UPDATE: "DAILY_REPORT_STATUS_UPDATE",
  START_DAILY_REPORT_REVIEW: "START_DAILY_REPORT_REVIEW",
};

export default PATCH_REQUEST_TYPE;
